define.alias("ember-useragent/instance-initializers/user-agent", "calendar/instance-initializers/user-agent");